import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=7cc7e38c&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=js&"
export * from "./Features.vue?vue&type=script&lang=js&"
import style0 from "./Features.vue?vue&type=style&index=0&id=7cc7e38c&prod&lang=scss&scoped=true&"
import style1 from "./Features.vue?vue&type=style&index=1&id=7cc7e38c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc7e38c",
  null
  
)

export default component.exports